// #region Imports

import * as $ from 'jquery'
import * as Responsiveness from '../ui/responsiveness'

// #endregion Imports

// #region Exports

export function initialize(): void {
    _element = $('#hero-shortcuts');
    if(_element.length === 0 || Responsiveness.smallerThan(Responsiveness.TABLET_LANDSCAPE)) {
        return;
    }

    wireScrollEvent();
    wireToggle();
    updateScrollspy();
}

// #endregion Exports

// #region Private members

let _isDocked = false;
let _isExpanded = false;
let _element;
let _offset;

// #endregion Private members

// #region Private functions

function wireScrollEvent() {
    _offset = _element.offset().top + _element.height() - 100;

    $(window).scroll(updateScrollspy);
}

function wireToggle() {
    $('.hero__shortcut-expander').click(handleToggleClick);
    $('.hero__shortcut').click(handleShortcutClick);
}

function handleShortcutClick(e) {
    _isExpanded = false;
    _element.removeClass('hero__shortcut-container--expanded')
}

function handleToggleClick(e) {
    if(_isExpanded) {
        _isExpanded = false;
        _element.removeClass('hero__shortcut-container--expanded')
    }
    else {
        _isExpanded = true;
        _element.addClass('hero__shortcut-container--expanded')
    }
}

function updateScrollspy() {
    const scrollTop = $(window).scrollTop();

    if(scrollTop > _offset && !_isDocked) {
        _isDocked = true;
        _element.addClass('hero__shortcut-container--docked')
    }
    else if(scrollTop <= _offset && _isDocked) {
        _isDocked = false;
        _element.removeClass('hero__shortcut-container--docked')
    }
}

// #endregion Private functions